var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2919 22.1697C13.2298 22.1697 15.5838 19.8148 15.5838 16.8778C15.5838 13.9409 13.2298 11.5859 10.2919 11.5859C7.35495 11.5859 5 13.9409 5 16.8778C5 19.8148 7.35495 22.1697 10.2919 22.1697Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2919 8.41972C11.8419 8.41972 13.0838 7.1773 13.0838 5.62783C13.0838 4.07836 11.8419 2.83594 10.2919 2.83594C8.74242 2.83594 7.5 4.07836 7.5 5.62783C7.5 7.1773 8.74242 8.41972 10.2919 8.41972Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5419 15.9197C23.0919 15.9197 24.3338 14.6773 24.3338 13.1278C24.3338 11.5784 23.0919 10.3359 21.5419 10.3359C19.9924 10.3359 18.75 11.5784 18.75 13.1278C18.75 14.6773 19.9924 15.9197 21.5419 15.9197Z",
    fill: "black",
    fillOpacity: 0.38
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0419 27.1697C20.5919 27.1697 21.8338 25.9273 21.8338 24.3778C21.8338 22.8284 20.5919 21.5859 19.0419 21.5859C17.4924 21.5859 16.25 22.8284 16.25 24.3778C16.25 25.9273 17.4924 27.1697 19.0419 27.1697Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.692d36419dbe77be8171ef6cfb686b88.svg";
export { ForwardRef as ReactComponent };